import FormActions from '../../logic/form-actions';
import FormType from '../../constants/form-type';
import LoginComponent from '../login-component';
import EmailInput from '../form-components/email-input';
import PasswordInput from '../form-components/password-input';
import ConfirmPasswordInput from '../form-components/confirm-password-input';
import ProductInformationInCheckbox from '../form-components/product-information-checkbox';
import TermsOfService from '../form-components/terms-of-service';
import RegisterSubmitButton from '../form-components/register-submit-button';
import LoginFormHeader from '../form-components/form-header';
import PasswordMode from '../../constants/password-mode';
import {localize} from '../../infrastructure/localization';

export default class Register extends LoginComponent {

    constructor(props) {
        super(props);
    }

    get titleText() {
        return this.isPromo
            ? localize('forms.register.title-promo')
            : localize('forms.register.title');
    }

    get subTitle() {
        if(this.isPromo) {
            return null;
        }

        return (
            <div className="subtitle-text">
                <span>{localize('forms.register.change-or')}</span>
                &nbsp;
                <a href="javascript:void(0)" onClick={() => FormActions.changeFormType(this.state.componentId, FormType.login)}>
                    {localize('forms.register.change-link')}
                </a>
            </div>
        );
    }

    get passwordElements() {
        switch (this.state.loginModel.passwordMode) {
            case PasswordMode.standard:
                return (
                    <div>
                        <PasswordInput componentId={this.state.componentId}  />
                        <ConfirmPasswordInput componentId={this.state.componentId}  />
                    </div>
                );

            case PasswordMode.singlePassword:
                return (<PasswordInput componentId={this.state.componentId}  />);

            default: return null;
        }
    }

    render () {
        return (
            <div className="forms-register">
                <LoginFormHeader componentId={this.state.componentId} title={this.titleText} subTitle={this.subTitle}  />

                <form className="login-form-content"
                      noValidate="true"
                      onSubmit={(e) => {e.preventDefault(); FormActions.register(this.state.componentId)}}>

                    <EmailInput componentId={this.state.componentId}  />

                    {this.passwordElements}

                    <TermsOfService componentId={this.state.componentId}  />

                    <ProductInformationInCheckbox componentId={this.state.componentId}  />

                    <RegisterSubmitButton componentId={this.state.componentId} />
                </form>
            </div>
        )
    }
};


/** WEBPACK FOOTER **
 ** ./src/components/forms/register.jsx
 **/